import React from "react";
import PropTypes from "prop-types";
import {IconButton, Tooltip, makeStyles} from "@material-ui/core";
import ClearSharpIcon from '@material-ui/icons/ClearSharp';
import DefaultType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import ValueInput from "./ValueInput";


const grayBorder = '1px solid rgba(0, 0, 0, 0.12)';
const useStyles = makeStyles(() => ({
    tagValueWrapper: {
        display: 'flex',
        width: '100%',
        '& $option': {
            visibility: 'hidden'
        },
        '&:hover': {
            '& $option': {
                visibility: 'visible'
            },
        }
    },
    tagValueWrapperHeader: {
        display: 'flex',
        width: '100%',
        height: 27,
    },
    tag: {
        width: '30%',
        borderLeft: grayBorder,
    },
    value: {
        width: '70%',
        borderLeft: grayBorder,
        borderRight: grayBorder,
        maxWidth: 496
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        width: 0
    },
    optionHeader: {
        width: 0,
    },
    tagHeader: {
        background: '#fafafa',
        width: '30%',
        borderTop: grayBorder,
        borderLeft: grayBorder,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    valueHeader: {
        background: '#fafafa',
        width: '70%',
        borderTop: grayBorder,
        borderLeft: grayBorder,
        borderRight: grayBorder,
        textAlign: 'center',
        maxWidth: 496,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    optionBtn: {
        padding: 0,
        left: -25
    },
    paramActionWrapper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    paramActionLine: {
        maxWidth: '709px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 2,
        cursor: 'pointer',
        borderLeft: grayBorder,
        borderRight: grayBorder,
        borderBottom: grayBorder,
        transition: 'all 0.2s ease',
        '& span': {
            display: 'none'
        },
        '&:hover': {
            height: 9,
            background: 'transparent',
            borderTop: grayBorder,
            borderBottom: grayBorder,
            borderLeft: 'none',
            borderRight: 'none',
            transition: 'all 0.2s ease',
            '& span': {
                display: 'block',
                color: 'rgba(0, 0, 0, 0.42)'
            }
        }
    }
}));

const TagValueParams = (props) => {
    const {actions, param, setValue, path, createParam, removeParam, actionIndex, onKeyDown, disabled} = props;
    const classes = useStyles();
    return (
        <>
            <div className={classes.tagValueWrapperHeader}>
                <div className={classes.tagHeader}>Tag</div>
                <div className={classes.valueHeader}>Value</div>
                <div className={classes.optionHeader}></div>
            </div>
            {(param || [{}]).map((par, index) => {
                return (
                    <React.Fragment key={index}>
                        {index === 0 && (
                            <div className={classes.paramActionLine}
                                 onClick={() => disabled ? () => {
                                 } : createParam(actionIndex, index)}>
                                <span>+</span>
                            </div>
                        )}
                        <div className={classes.tagValueWrapper} onKeyDown={(e) => onKeyDown(e, index)}>
                            <div className={classes.tag}>
                                <DefaultType
                                    field={{path: `${path}.param.${index}.tag`, disabled}}
                                    fieldStyles={{withoutStyles: true, fullWidth: true}}
                                    setValue={setValue}
                                    showLabel={true}
                                    values={actions}
                                />
                            </div>
                            <div className={classes.value}>
                                <div style={{maxWidth: 471}}>
                                    <ValueInput
                                        disabled={disabled}
                                        path={path}
                                        paramIndex={index}
                                        actionIndex={actionIndex}
                                        currentParam={par}
                                        setValue={setValue}
                                        createParam={createParam}
                                        param={param}

                                    />
                                </div>
                            </div>
                            <div className={classes.option}>
                                <Tooltip title={'Remove Param'}>
                                    <IconButton tabIndex={-1}
                                                disabled={disabled}
                                                onClick={() => removeParam(actionIndex, index)}
                                                className={classes.optionBtn}>
                                        <ClearSharpIcon fontSize={"small"}/>
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                        <div className={classes.paramActionLine}
                             onClick={() => disabled ? () => {
                             } : createParam(actionIndex, index + 1)}>
                            <span>+</span>
                        </div>
                    </React.Fragment>
                )
            })}
        </>
    )
};
export default TagValueParams

TagValueParams.propTypes = {
    param: PropTypes.array,
    actions: PropTypes.array,
    setValue: PropTypes.func,
    path: PropTypes.string,
    createParam: PropTypes.func,
    removeParam: PropTypes.func,
    actionIndex: PropTypes.number,
    disabled: PropTypes.bool
};